module.exports = __webpack_public_path__ + "49939d8e6154fb6c0822b12a9753638f.pdf";